import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { useDerivedValue, useSharedValue } from 'react-native-reanimated';
import StatusBar from 'design-system/StatusBar';
import { AppView, NavigationHeader } from 'design-system';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import InvestWalkthrough from 'features/feed/components/walkthrough/InvestWalkthrough';
import useInvestWalkthroughLayout from 'features/feed/components/walkthrough/useInvestWalkthroughLayout';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import FundPickerFloatingBar from '../components/FundPickerFloatingBar';
import useFundPickerStore from '../hooks/useFundPickerStore';
import DiscoverShortcutsSeccl from '../components/DiscoverShortcutsSeccl';
import { selectActiveTradingAccountBroker } from '../reducers/selectors';
import DiscoverSecclHeaderExtension from './DiscoverSecclHeaderExtension';
import { isWeb } from '../../../constants';
const DiscoverScreen = ({ navigation, route }) => {
    const colors = useColors();
    const { active: isFundPickerActive, mode: fundPickerMode } = useFundPickerStore();
    const isAlpacaAccount = useAppSelector(selectActiveTradingAccountBroker) === 'alpaca';
    const scrollX = useSharedValue(0);
    const scrollYReadyMade = useSharedValue(0);
    const scrollYDoItYourself = useSharedValue(0);
    const { contentWidth, paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const finalScrollY = useDerivedValue(() => {
        if (scrollX.value >= contentWidth / 2) {
            return scrollYDoItYourself.value;
        }
        return scrollYReadyMade.value;
    }, [contentWidth, scrollX, scrollYDoItYourself, scrollYReadyMade]);
    const secclHorizontalScrollViewRef = useRef(null);
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Discover',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const { itemPositions, scrollHeight, scrollLayoutHeight, onScrollLayout } = useInvestWalkthroughLayout();
    const startInDoItYourself = route.params?.start ? route.params.start === 'doItYourself' : undefined;
    useEffect(() => {
        if (isAlpacaAccount && navigation.canGoBack()) {
            navigation.goBack();
        }
    }, [isAlpacaAccount]);
    if (isAlpacaAccount) {
        return null;
    }
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <View style={styles.flex} onLayout={onScrollLayout}>
        {/* On web the header's own frame ignores the sidebar, so the selector
            would sit in a narrower column than the content; frame it here instead */}
        <NavigationHeader scrollY={finalScrollY} withFrame={!isWeb}>
          <View style={isWeb ? paddingHorizontalStyle : undefined}>
            <DiscoverSecclHeaderExtension scrollX={scrollX} scrollY={finalScrollY} secclHorizontalScrollViewRef={secclHorizontalScrollViewRef}/>
          </View>
        </NavigationHeader>
        <DiscoverShortcutsSeccl scrollX={scrollX} scrollYReadyMade={scrollYReadyMade} scrollYDoItYourself={scrollYDoItYourself} startInDoItYourself={startInDoItYourself} secclHorizontalScrollViewRef={secclHorizontalScrollViewRef} hideSeeAllFunds={!!(isFundPickerActive && fundPickerMode === 'multi')}/>

        <InvestWalkthrough isInTab={false} scrollHeight={scrollHeight} itemPositions={itemPositions} scrollLayoutHeight={scrollLayoutHeight}/>
      </View>
      {isFundPickerActive ? <FundPickerFloatingBar /> : null}
    </AppView>);
};
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
});
export default DiscoverScreen;
